module.exports = {"public_path":"view/","tech_api":"https://tech.serviziortodontici.3d-plan.online","client_api":"https://serviziortodontici-dide.com","type":"standalone"}


//////////////////
// WEBPACK FOOTER
// ./src/api.json
// module id = 43
// module chunks = 0